import slugify from 'slugify'

export const slugifyHeading = (heading: string) =>
  slugify(heading, {
    lower: true,
    strict: true,
    locale: 'no',
  })

export const validSlugRegex = /[^A-Za-z0-9_-]/
